function formatoRut(persona) {
  if (persona) {
    if (persona.tipoIdentificacion == 'C') {
      return `${persona.numeroIdentificacion} - ${persona.dv}`;
    }
    if (persona.tipoIdentificacion == 'P') {
      return `${persona.tipoIdentificacion}  ${persona.numeroIdentificacion}`;
    }
    if (persona.tipoIdentificacion == 'I') {
      return `IPE ${persona.numeroIdentificacion}`;
    }
  }
  return '';
}

function nombreCompleto(persona) {
  return persona ? `${persona.paterno} ${persona.materno} ${persona.nombres}` : '';
}

async function getGtoken(key, action) {
  return new Promise(resolve => {
    window.grecaptcha.ready(function() {
      window.grecaptcha.execute(key, {action}).then(token => resolve(token));
    });
  });
}

const arrayToObject = (array, fxKey, fxValue) => {
  if (!array) {
    return {};
  }
  return array.reduce ((obj, item) => {
    obj [fxKey(item)] = fxValue(item);
    return obj;
    }
  , {})
};

function getCantidadPisos() {
  const inicio = 1;
  const fin = 10;
  return [...Array(fin - inicio).keys()].map(index => inicio + index);
}

module.exports = {
  formatoRut,
  nombreCompleto,
  getGtoken,
  arrayToObject,
  getCantidadPisos,
};
